import * as general from "./general";
import * as api from "./api";
import * as cookie from "./cookie";

export const h = {
    general,
    api,
    cookie,
};
